export const SELF_ASSESSMENT_FIELDS_STAFF_RESPONSABILITY_LEADERSHIP = {
  men: {
    fields: [
      "selfAssessment_staff_responsibility_management_executiveDirector_men",
      "selfAssessment_staff_responsibility_management_director_men",
      "selfAssessment_staff_responsibility_management_middleLevel4_men",
      "selfAssessment_staff_responsibility_management_middleLevel3_men",
      "selfAssessment_staff_responsibility_management_middleLevel2_men",
      "selfAssessment_staff_responsibility_management_middleLevel1_men",
    ],
    subtotal: "selfAssessment_staff_responsibility_management_subtotal_men",
    total: "selfAssessment_staff_responsibility_total_men",
  },
  women: {
    fields: [
      "selfAssessment_staff_responsibility_management_executiveDirector_women",
      "selfAssessment_staff_responsibility_management_director_women",
      "selfAssessment_staff_responsibility_management_middleLevel4_women",
      "selfAssessment_staff_responsibility_management_middleLevel3_women",
      "selfAssessment_staff_responsibility_management_middleLevel2_women",
      "selfAssessment_staff_responsibility_management_middleLevel1_women",
    ],
    subtotal: "selfAssessment_staff_responsibility_management_subtotal_women",
    total: "selfAssessment_staff_responsibility_total_women",
  },
};

export const SELF_ASSESSMENT_FIELDS_STAFF_RESPONSABILITY_OTHER_POSITIONS = {
  women: {
    fields: [
      "selfAssessment_staff_responsibility_otherPositions_technical_women",
      "selfAssessment_staff_responsibility_otherPositions_administrative_women",
      "selfAssessment_staff_responsibility_otherPositions_support_women",
      "selfAssessment_staff_responsibility_otherPositions_operational_women",
    ],
    subtotal:
      "selfAssessment_staff_responsibility_otherPositions_subtotal_women",
    total: "selfAssessment_staff_responsibility_total_women",
  },
  men: {
    fields: [
      "selfAssessment_staff_responsibility_otherPositions_technical_men",
      "selfAssessment_staff_responsibility_otherPositions_administrative_men",
      "selfAssessment_staff_responsibility_otherPositions_suport_men",
      "selfAssessment_staff_responsibility_otherPositions_operational_men",
    ],
    subtotal: "selfAssessment_staff_responsibility_otherPositions_subtotal_men",
    total: "selfAssessment_staff_responsibility_total_men",
  },
};

export const SELF_ASSESSMENT_FIELDS_STAFF_BY_DEPARTMENT = {
  women: {
    fields: [
      "selfAssessment_staff_department_administration_women",
      "selfAssessment_staff_department_commercial_women",
      "selfAssessment_staff_department_logistics_women",
      "selfAssessment_staff_department_production_women",
      "selfAssessment_staff_department_service_women",
      "selfAssessment_staff_department_technical_women",
      "selfAssessment_staff_department_humanResources_women",
    ],
    total: "selfAssessment_staff_department_total_women",
  },
  men: {
    fields: [
      "selfAssessment_staff_department_administration_men",
      "selfAssessment_staff_department_commercial_men",
      "selfAssessment_staff_department_logistics_men",
      "selfAssessment_staff_department_production_men",
      "selfAssessment_staff_department_service_men",
      "selfAssessment_staff_department_technical_men",
      "selfAssessment_staff_department_humanResources_men",
    ],
    total: "selfAssessment_staff_department_total_men",
  },
};

export const SELF_ASSESSMENT_FIELDS_STAFF_BOARD_OF_DIRECTORS = {
  women: {
    fields: ["selfAssessment_staff_board_women"],
  },
  men: {
    fields: ["selfAssessment_staff_board_men"],
  },
};

export const SELF_ASSESSMENT_FIELDS_BY_DEMOGRAPHICS_AGE = {
  women: {
    fields: [
      "selfAssessment_staff_byDemographics_age_under18_women",
      "selfAssessment_staff_byDemographics_age_between18And30_women",
      "selfAssessment_staff_byDemographics_age_between31And60_women",
      "selfAssessment_staff_byDemographics_age_older60_women",
    ],
  },
  men: {
    fields: [
      "selfAssessment_staff_byDemographics_age_under18_men",
      "selfAssessment_staff_byDemographics_age_between18And30_men",
      "selfAssessment_staff_byDemographics_age_between31And60_men",
      "selfAssessment_staff_byDemographics_age_older60_men",
    ],
  },
};

export const SELF_ASSESSMENT_FIELDS_BY_DEMOGRAPHIC_DISABILITIES = {
  women: {
    fields: [
      "selfAssessment_staff_byDemographics_disability_yes_women",
      "selfAssessment_staff_byDemographics_disability_no_women",
    ],
  },
  men: {
    fields: [
      "selfAssessment_staff_byDemographics_disability_yes_men",
      "selfAssessment_staff_byDemographics_disability_no_men",
    ],
  },
};

export const SELF_ASSESSMENT_FIELDS_BY_ETHNIC_IDENTITY = {
  women: {
    fields: [
      "selfAssessment_staff_byDemographics_ethnicIdentity_afrodescendant_women",
      "selfAssessment_staff_byDemographics_ethnicIdentity_asian_women",
      "selfAssessment_staff_byDemographics_ethnicIdentity_hispanic_women",
      "selfAssessment_staff_byDemographics_ethnicIdentity_indigenous_women",
      "selfAssessment_staff_byDemographics_ethnicIdentity_other_women",
    ],
  },
  men: {
    fields: [
      "selfAssessment_staff_byDemographics_ethnicIdentity_afrodescendant_men",
      "selfAssessment_staff_byDemographics_ethnicIdentity_asian_men",
      "selfAssessment_staff_byDemographics_ethnicIdentity_hispanic_men",
      "selfAssessment_staff_byDemographics_ethnicIdentity_indigenous_men",
      "selfAssessment_staff_byDemographics_ethnicIdentity_other_men",
    ],
  },
};

export const SELF_ASSESSMENT_FIELDS_BY_ETHNIC_SENIORITY = {
  women: {
    fields: [
      "selfAssessment_staff_byDemographics_seniority_less2_women",
      "selfAssessment_staff_byDemographics_seniority_between2And5_women",
      "selfAssessment_staff_byDemographics_seniority_between5And10_women",
      "selfAssessment_staff_byDemographics_seniority_more10_women",
    ],
  },
  men: {
    fields: [
      "selfAssessment_staff_byDemographics_seniority_less2_men",
      "selfAssessment_staff_byDemographics_seniority_between2And5_men",
      "selfAssessment_staff_byDemographics_seniority_between5And10_men",
      "selfAssessment_staff_byDemographics_seniority_more10_men",
    ],
  },
};

export const SELF_ASSESSMENT_FIELDS_BY_GENDER_IDENTITY = {
  women: {
    fields: [
      "selfAssessment_staff_byDemographics_genderIdentity_womenMen_women",
      "selfAssessment_staff_byDemographics_genderIdentity_transgenderMen_women",
      "selfAssessment_staff_byDemographics_genderIdentity_transgenderWomen_women",
      "selfAssessment_staff_byDemographics_genderIdentity_genderNonConforming_women",
      "selfAssessment_staff_byDemographics_genderIdentity_other_women",
    ],
  },
  men: {
    fields: [
      "selfAssessment_staff_byDemographics_genderIdentity_womenMen_men",
      "selfAssessment_staff_byDemographics_genderIdentity_transgenderMen_men",
      "selfAssessment_staff_byDemographics_genderIdentity_transgenderWomen_men",
      "selfAssessment_staff_byDemographics_genderIdentity_genderNonConforming_men",
      "selfAssessment_staff_byDemographics_genderIdentity_other_men",
    ],
  },
};
